import external from "@/gavnoCode/external";
import errorHandlerExternal from "@/plugins/errorHandlerExternal";
import router from "@/router";
import kostili from "@/gavnoCode/Kostili";
import bookeepingServices from "@/for_MS/bookeepingServices";

const state = {
  isDeveloper: localStorage.getItem('Position') === '365' || localStorage.getItem('Position') === '355',
  TEST: 0,
  NP: localStorage.getItem('UserID') === '75889',
  // NP: localStorage.getItem('UserID') === '105926',
  sheets: [],
  tablesList: [],
  tablesObj: {
    EPgreed: {},
    PEgreed: {},
    dateDiscrepancy: {},
    sverSumm: {},
    topUp_greed: {},
    oneCaccountObj: {},
    RPgreed2: {},
    RPgreed3: {},
    RPgreed4: {},
    YLgreed1: {},
    YLgreed2: {},
    YLgreed3: {},
    YLgreed4: {},
    recommendedGreed: {},
    failedDPgreed: {},
    failedLongations: {},
    outstandingPayments: {},
    unknownPayments: {},
    inPaysNotPolotno: {},
    inPolotnoNotPays: {},
    Inequality76051: {},
    Inequality76093: {},
    CheckDoubleOrders: {},
    CheckPairTrans: {},
    CheckMinusSumTrans: {},
    remains_greed1: {},
    remains_greed2: {},
    remains_greed3: {},
    remains_greed4: {},
    summaryTable: {},
  },
  operday: '',
  currentTab: '',
  statementOfChecks: {
    yrl: {counter: 0, check: false},
    vyd: {counter: 0, check: false},
    sver: {counter: 0, check: false},
    so: {counter: 0, check: false},
    pp: {counter: 0, check: false},
    ps: {counter: 0, check: false},
    op: {counter: 0, check: false},
    po: {counter: 0, check: false},
    st: {counter: 0, check: false},
  },
  canCloseOperDay: false,
  calcInProgress: false,
  calcStatus: '',
  remCalc: false,
  summCalc: false,
  summPeriodCalc: false,
  vitrinaCalc: false,
  enterpriseListVuex: [],
  reports: {
    analitSborIn: [],
    raspredSbor: []
  },
  dtStart: '',
  dtEnd: '',
  reportDate: '',
};

const getters = {
};

const actions = {
  createSheet: ({commit}, data) => {
    let sheetObj = {
      sheet_name: data.sheetName,
      tables: [],
    }
    let foundIndex = state.sheets.findIndex((item) => {
      return item.sheet_name === data.sheetName
    })
    if (foundIndex < 0) {
      commit('pushNewSheet', sheetObj)
    } else {
      console.log('такой excel лист (объект) уже есть')
    }
  },
  saveTableSheet: ({commit}, data) => {
    let table = {
      table_name: data.tableName,
      ref_columns: data.ref,
      list_json: data.list
    }
    commit('createTableInSheet', { table: table, target: data.sheetName });
  },
  getBigXls: async ({commit}) => {
    commit('loadingStatus', true);
    await bookeepingServices.callBuhApi({
      method: 'POST',
      apiPath: '/Excel/createExcel_lists',
      data: state.sheets
    }).then((res) => {

      const xlsxStr = atob(res);
      const byteNumbers = new Array(xlsxStr.length);
      for (let i = 0; i < xlsxStr.length; i++) {
        byteNumbers[i] = xlsxStr.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: '' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'def' + '.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      commit('loadingStatus', false);
    }).catch((res) => {
      // console.log('в родителе что-то отрыгнуло');
      // console.log(res);
      errorHandlerExternal(res, router, 'getBigXls');
      commit('loadingStatus', false);
    })
  },
  setDateDefault: ({commit}) => {
    const now = new Date()
    // Получаем прошлый месяц (если сейчас январь, год уменьшится автоматически)
    let lastMonthYear = now.getFullYear()
    let lastMonth = now.getMonth() - 1
    if (lastMonth < 0) {
      lastMonth = 11 // Декабрь
      lastMonthYear -= 1
    }
    // Дата начала: 1-е число прошлого месяца, время 00:00:00
    const startDate = new Date(lastMonthYear, lastMonth, 1)
    startDate.setHours(0, 0, 0, 0)

    // Дата конца: 1-е число текущего месяца минус 1 миллисекунда
    // Это самый надежный способ получить последний день любого месяца
    const endDate = new Date(now.getFullYear(), now.getMonth(), 0)
    endDate.setHours(23, 59, 59, 999)

    commit('setReportDate', kostili.formatDate(endDate));
    commit('setDtStart', kostili.formatDate(startDate));
    commit('setDtEnd', kostili.formatDate(endDate));
  },
  DailyCheckList: ({commit, dispatch}) => {
    commit('loadingStatus', true);
    external.universalRequest({
      externalType: 'ms',
      msUrl: 'back-loannp/Buh/DailyCheckList',
      method: 'GET',
    }).then((res) => {
      dispatch('prepareTablesList', res.list);
      dispatch('collectCheckResults', res.list);
      commit('setOperday', res.dtOperDay);
      commit('loadingStatus',false);
    }).catch(res => {
      alert('DailyCheckList catch');
      errorHandlerExternal(res, router, 'DailyCheckList');
      commit('loadingStatus', false);
    })
  },
  clearAndSaveListForExcel: ( {commit}, data ) => {
    const out = [];
    if (data.list.length === 0) {
      return false;
    }
    data.list.forEach((originalItem) => {
      const newItem = {};
      for (const key in originalItem) {
        if (!Object.prototype.hasOwnProperty.call(originalItem, key)) continue;
        if (key.endsWith('_original') || key === 'lineStr' || key === 'status_color' ) {
          continue;
        }
        newItem[key] = originalItem[key];
      }
      out.push(newItem);
    });
    data.list = out;
    commit('saveReport', data );
  },
  getEnterpriseListVuex: ({commit}) => {
    commit('loadingStatus', true);
    external.universalRequest({
      externalType: 'ms',
      msUrl: 'back-loannp/Buh/get_enterprise_list',
      method: 'GET',
    }).then((res) => {
      let arr = []
      for (let i = 0; i < res.length; i++) {
        arr.push( {key: res[i].id, value: res[i].name} )
      }
      commit('saveEnterpriseList', arr);
      commit('loadingStatus',false);
    }).catch(res => {
      errorHandlerExternal(res, router, 'getEnterpriseListVuex');
      commit('loadingStatus', false);
    })
  },
  collectCheckResults: ({commit}, list) => {
    console.log('collectCheckResults');
    let vyd = [1, 2, 3, 4, 5, 26];
    let vydStatus = 0;
    for (let i=0; i<vyd.length; i++) {
      let finded = list.find(index => index.tableID === vyd[i]);
      if (finded.checkResult === -1) {
        vydStatus = -1
        commit('saveChecksStatus', {status: vydStatus, target: 'vyd', check: vydStatus === vyd.length });
        break;
      } else if (finded.checkResult > 0) {
        vydStatus++
      } else break
      commit('saveChecksStatus', {status: vydStatus, target: 'vyd', check: vydStatus === vyd.length });
    }

    let sver = [6, 7, 8];
    let sverStatus = 0;
    for (let i=0; i<sver.length; i++) {
      let finded = list.find(index => index.tableID === sver[i]);
      if (finded.checkResult === -1) {
        sverStatus = -1
        commit('saveChecksStatus', {status: sverStatus, target: 'sver', check: sverStatus === sver.length});
        break;
      } else if (finded.checkResult > 0) {
        sverStatus++
      } else break
      commit('saveChecksStatus', {status: sverStatus, target: 'sver', check: sverStatus === sver.length});
    }

    let so = [9, 10, 11];
    let soStatus = 0;
    for (let i=0; i<so.length; i++) {
      let finded = list.find(index => index.tableID === so[i]);
      if (finded.checkResult === -1) {
        soStatus = -1
        commit('saveChecksStatus', {status: soStatus, target: 'so', check: soStatus === so.length});
        break;
      } else if (finded.checkResult > 0) {
        soStatus++
      } else break
      commit('saveChecksStatus', {status: soStatus, target: 'so', check: soStatus === so.length});
    }

    let pp = [12, 13, 14, 15];
    let ppStatus = 0;
    for (let i=0; i<pp.length; i++) {
      let finded = list.find(index => index.tableID === pp[i]);
      if (finded.checkResult === -1) {
        ppStatus = -1
        commit('saveChecksStatus', {status: ppStatus, target: 'pp', check: ppStatus === pp.length});
        break;
      } else if (finded.checkResult > 0) {
        ppStatus++
      } else break
      commit('saveChecksStatus', {status: ppStatus, target: 'pp', check: ppStatus === pp.length});
    }

    let ps = [16, 17];
    let psStatus = 0;
    for (let i=0; i<ps.length; i++) {
      let finded = list.find(index => index.tableID === ps[i]);
      if (finded.checkResult === -1) {
        psStatus = -1
        commit('saveChecksStatus', {status: psStatus, target: 'ps', check: psStatus === ps.length});
        break;
      } else if (finded.checkResult > 0) {
        psStatus++
      } else break
      commit('saveChecksStatus', {status: psStatus, target: 'ps', check: psStatus === ps.length});
    }

    let op = [18, 19, 20];
    let opStatus = 0;
    for (let i=0; i<op.length; i++) {
      let finded = list.find(index => index.tableID === op[i]);
      if (finded.checkResult === -1) {
        opStatus = -1
        commit('saveChecksStatus', {status: opStatus, target: 'op', check: opStatus === op.length});
        break;
      } else if (finded.checkResult > 0) {
        opStatus++
      } else break
      commit('saveChecksStatus', {status: opStatus, target: 'op', check: opStatus === op.length});
    }

    let po = [21, 22, 23, 24];
    let poStatus = 0;
    for (let i=0; i<po.length; i++) {
      let finded = list.find(index => index.tableID === po[i]);
      if (finded.checkResult === -1) {
        poStatus = -1
        commit('saveChecksStatus', {status: poStatus, target: 'po', check: poStatus === po.length});
        break;
      } else if (finded.checkResult > 0) {
        poStatus++
      } else break
      commit('saveChecksStatus', {status: poStatus, target: 'po', check: poStatus === po.length});
    }

    let st = [25];
    let stStatus = 0;
    for (let i=0; i<st.length; i++) {
      let finded = list.find(index => index.tableID === st[i]);
      if (finded.checkResult === -1) {
        stStatus = -1
        commit('saveChecksStatus', {status: stStatus, target: 'st', check: stStatus === st.length});
        break;
      } else if (finded.checkResult > 0) {
        stStatus++
      } else break
      commit('saveChecksStatus', {status: stStatus, target: 'st', check: stStatus === st.length});
    }

    let yrl = [27, 28, 29];
    let yrlStatus = 0;
    for (let i=0; i<yrl.length; i++) {
      let finded = list.find(index => index.tableID === yrl[i]);
      if (finded.checkResult === -1) {
        yrlStatus = -1
        commit('saveChecksStatus', {status: yrlStatus, target: 'yrl', check: yrlStatus === yrl.length});
        break;
      } else if (finded.checkResult > 0) {
        yrlStatus++
      } else break
      commit('saveChecksStatus', {status: yrlStatus, target: 'yrl', check: yrlStatus === yrl.length});
    }

  },
  prepareTablesList: ({commit}, tablesList) => {
    let count = 0;
    for (let i=0; i<tablesList.length; i++) {
      if ( tablesList[i].checkResult !== 1 ) {
        count ++
      }
      tablesList[i]['showButtons'] = true;
    }
    commit('setClosingStatement', count === 0)

    commit('setTablesList', tablesList)
  },
  getNeededObj: ({commit}, dataObj) => {
    let findedObj = state.tablesList.findIndex(index => index.tableID === dataObj.id);
    if (findedObj >= 0) {
      commit('addTablesObj', {obj: state.tablesList[findedObj],name: dataObj.name})
    }
  },
  getCalcStatus: ({commit}, statusObj) => {
    let status = '';
    switch (statusObj.statusRes) {
      case 1: status = 'Расчет завершился успешно';
      break;
      case -1: status = 'Расчет завершился с ошибкой';
      break;
      case 0: status = 'В процессе';
      break;
      case 100: status = 'Расчет не проводился';
      break;
      default: break;
    }
    commit('setCalcStatus', status);
  },
};

const mutations = {
  setLoopValue:(state, loopObj) => {state[loopObj.loopTarget] = loopObj.value},
  setTest:(state, value) => state.TEST = value,
  setDtStart:(state, date) => state.dtStart = date,
  setDtEnd:(state, date) => state.dtEnd = date,
  setReportDate:(state, repDate) => state.reportDate = repDate,
  setSelectedTab:(state, value) => state.currentTab = value,
  setTablesList:(state, tablesArray) => {
    state.tablesList = tablesArray
  },
  addTablesObj: (state, newTableObj) => state.tablesObj[newTableObj.name] = newTableObj.obj,
  setOperday:(state, value) => { state.operday = value },
  saveEnterpriseList:(state, list) => { state.enterpriseListVuex = list },
  setClosingStatement:(state, value) => state.canCloseOperDay = value,
  setCalcProgress: (state, value) => state.calcInProgress = value,
  setCalcStatus: (state, value) => state.calcStatus = value,
  saveChecksStatus: (state, obj) => {
    state.statementOfChecks[obj.target].counter = obj.status;
    state.statementOfChecks[obj.target].check = obj.check;
  },
  saveReport: (state, data) => state.reports[data.target] = data.list,
  pushNewSheet: (state, data) => state.sheets.push(data),
  createTableInSheet: (state, data) => {
    let foundIndex = state.sheets.findIndex((sheet) => {
      return sheet.sheet_name === data.target
    })
    if (foundIndex >= 0) {
      let tableIndex = state.sheets[foundIndex].tables.findIndex((item) => {
        return item.table_name === data.table.table_name;
      })
      if (tableIndex < 0) {
        state.sheets[foundIndex].tables.push(data.table);
      } else {
        state.sheets[foundIndex].tables[tableIndex] = data.table;
      }
    }
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
}
